<!-- Desktop/Tablet Header -->
<div class="header-desktop d-none d-md-flex">
  <!-- Pierwszy wiersz - Logo, nazwa firmy, moje konto -->
  <div class="desktop-header-row">
    <div class="header-container">
      <div class="logo-container">
        <a href="#" class="sidebar-toggle" (click)="toggleSidebar()">
          <nb-icon [icon]="isMainSidebarOpen ? 'close-outline' : 'menu-2-outline'"></nb-icon>
        </a>
        <a class="logo" href="#" (click)="navigateHome($event)">
          <img class="logo-img" src="assets/images/logo-smart.png">
        </a>
      </div>
    </div>

    <!-- Wycentrowana nazwa firmy -->
    <div class="company-name-center">
      <b>{{ nazwa() }}</b>
    </div>
    
    <div class="header-container">
      <nb-actions size="small" class="mobile-actions">
        <nb-action title="{{ 'etykieta.moje-konto' | translate }}" icon="person-outline" (click)="toggleAccountSidebar()"></nb-action>
      </nb-actions>
    </div>
  </div>

  <!-- Drugi wiersz - Przyciski akcji -->
  <div class="desktop-header-row desktop-secondary">
    <div class="desktop-actions">
      <div class="desktop-contact" *ngIf="kontakt && kontakt.opiekunGlownyImieNazwisko">
        <ngx-header-contact-menu [kontakt]="kontakt"></ngx-header-contact-menu>
      </div>
      <div class="desktop-saldeo-button">
        <ngx-header-saldeo-button label="akcja.saldeo-dodaj-dokument"></ngx-header-saldeo-button>
      </div>
      <div class="desktop-saldeo-button">
        <ngx-header-saldeo-button label="akcja.saldeo-wystaw-fakture"></ngx-header-saldeo-button>
      </div>
      <div class="desktop-faktury-button">
        <ngx-header-faktury-button></ngx-header-faktury-button>
      </div>
      <div class="desktop-zus-button" *ngIf="isKFType() || isKOType()">
        <ngx-header-zus-button></ngx-header-zus-button>
      </div>
    </div>
  </div>
</div>

<!-- Mobile Header -->
<div class="header-mobile d-flex d-md-none">
  <!-- Pierwszy wiersz - Logo i podstawowe kontrolki -->
  <div class="mobile-header-row">
    <div class="mobile-left">
      <a href="#" class="sidebar-toggle" (click)="toggleSidebar()">
        <nb-icon [icon]="isMainSidebarOpen ? 'close-outline' : 'menu-2-outline'"></nb-icon>
      </a>
      <a class="logo" href="#" (click)="navigateHome($event)">
        <img class="logo-img-mobile" src="assets/images/logo.png">
      </a>
    </div>
    <div class="mobile-right">
      <div class="mobile-user-name">{{ nazwa() }}</div>
      <!-- <ngx-wybor-jezyka-menu class="mobile-control"></ngx-wybor-jezyka-menu> -->
      <nb-actions size="small" class="mobile-actions">
        <nb-action title="{{ 'etykieta.moje-konto' | translate }}" icon="person-outline" (click)="toggleAccountSidebar()"></nb-action>
      </nb-actions>
    </div>
  </div>

  <!-- Drugi wiersz - Kontakt i dodatkowe opcje (jeśli potrzebne) -->
  <div class="mobile-header-row mobile-secondary">
    <div class="mobile-contact" *ngIf="kontakt && kontakt.opiekunGlownyImieNazwisko">
      <ngx-header-contact-menu [kontakt]="kontakt"></ngx-header-contact-menu>
    </div>
    <div class="mobile-saldeo-button-container">
      <ngx-header-saldeo-button label="akcja.saldeo-dodaj-dokument"></ngx-header-saldeo-button>
    </div>
    <div class="mobile-saldeo-button-container">
      <ngx-header-saldeo-button label="akcja.saldeo-wystaw-fakture"></ngx-header-saldeo-button>
    </div>
    <div class="mobile-faktury-button-container">
      <ngx-header-faktury-button></ngx-header-faktury-button>
    </div>
    <div class="mobile-zus-button-container" *ngIf="isKFType() || isKOType()">
      <ngx-header-zus-button></ngx-header-zus-button>
    </div>
  </div>
</div>

<!-- User Account Sidebar -->
<ngx-user-account-sidebar 
  [isOpen]="isAccountSidebarOpen" 
  [user]="user"
  (onClose)="closeAccountSidebar()"
  (onLogout)="confirmLogout()">
</ngx-user-account-sidebar>